
import { defineComponent } from 'vue'
import { setI18nLanguage } from '@/i18n'
import { LanguagesType } from '@/types'
import { constants } from '@/constants'
import AsahiLogoNew from '@/components/library/assets/AsahiLogoNew.vue'
import AsahiLanguageSelector from '@/components/library/AsahiLanguageSelector.vue'
import AsahiButton from '@/components/library/AsahiButton.vue'
import AsahiBsFooter from '@/components/library/AsahiBsFooter.vue'
import { IPortalHardCodeLink } from '@/store/modules/links/interfaces/IPortalHardCodeLink'
import BreadcrumbLayout from '@/components/library/BreadcrumbLayout.vue'

export default defineComponent({
  name: 'BeforeLoginLayout',
  components: {
    AsahiLanguageSelector,
    AsahiButton,
    AsahiLogoNew,
    AsahiBsFooter,
    BreadcrumbLayout
  },
  data: () => ({
    activeLanguage: (localStorage.getItem('lang')) as LanguagesType,
    theme: constants.application.theme
  }),

  inject: ['isPeroni'],

  computed: {

    isOnForgotPassword () {
      return this.$route.name === 'forgotPassword'
    },

    isInLoginPage () {
      return this.$route.name === 'login'
    },
    user () {
      return this.$store.state.auth.user
    },
    linksStore () {
      return this.$store.state.links
    },
    languages () {
      return ['pl', 'en']
    },
    portalPageMenuLink () {
      return this.$store.state.links.portalPageMenuLink?.items ?? []
    },
    portalHardCodeLink (): IPortalHardCodeLink[] {
      return this.$store.state.links.portalHardCodeLink?.results ?? []
    },

    footerLinksBrands () {
      const beforeLoginBrands = [
        'brandTyskie', 'brandLech', 'brandZubr', 'brandKsiazece', 'brandVelkopopovicky', 'brandDebowe',
        'brandHardmade', 'brandPilsner', 'brandLechPils', 'brandPilsnerUrquell'
      ]
      const brandLinks = this.portalHardCodeLink
        .filter((data) => data.type.toLowerCase() === 'Mobile Brands PL'.toLowerCase() && beforeLoginBrands.includes(data.name))
        .map((data) => ({
          label: data.label,
          link: data.url,
          target: '_blank',
          order: data.order
        }))
        .sort((a, b) => a.order - b.order)

      return [
        ...brandLinks
      ]
    },
    footerLinksCookies () {
      const aboutUsLinks = this.portalHardCodeLink
        .filter((data) => data.name === 'cookies')
        .map((data) => ({
          label: this.$t('Cookies'),
          href: data.url,
          target: '_blank'
        }))
      return aboutUsLinks
    },
    footerLinksTermsOfUse () {
      const aboutUsLinks = this.portalHardCodeLink
        .filter((data : any) => data.name === 'termsOfUse')
        .map((data: any) => ({
          label: this.$t('Terms of use'),
          href: data.url,
          target: '_blank'
        }))
      return aboutUsLinks
    },
    footerLinksPrivacyPolicy () {
      const aboutUsLinks = this.portalHardCodeLink
        .filter((data: any) => data.name === 'privacyPolicy')
        .map((data: any) => ({
          label: this.$t('Privacy policy'),
          href: data.url,
          target: '_blank'
        }))
      return aboutUsLinks
    }
  },
  mounted () {
    if (localStorage?.getItem('lang') === 'null') {
      this.activeLanguage = this.languages[0] as LanguagesType
    } else {
      this.activeLanguage = (localStorage?.getItem('lang') || this.languages[0]) as LanguagesType
    }
    setI18nLanguage(this.activeLanguage)
  },

  methods: {
    changeLanguage (langCode: LanguagesType) {
      this.activeLanguage = langCode
      setI18nLanguage(langCode)
    },
    userLogout () {
      sessionStorage.removeItem('uid')
      sessionStorage.removeItem('imp_usr')
      const params = {
        UID: this.user.UID,
        callback: this.handleLogout
      }
      window.gigya.accounts.logout(params)
    },
    /**
     * Method to perform action after user logs out
     * Navigate user to home page
     */
    handleLogout () {
      this.$store.dispatch('logout')
      // this.$navigate('/login')
      this.$navigate('/')
    }
  }
})
